import d3 from './d3-lib'
import moment from 'moment-timezone'
import { round } from 'utils/common'

const margin = { top: 20, right: 30, bottom: 20, left: 50 }
const marketTimes = {
  US: {
    totalseconds: 390,
    range: [0, 100, 200],
    dote: [0, 195, 390],
    ticks: ['9:30', '12:45', '16:00']
  },
  HK: {
    totalseconds: 330,
    range: [0, (150 / 330) * 200, 200],
    dote: [0, 150, 330],
    times: ['9:30', '12:00', '13:00', '16:00'],
    ticks: ['9:30', '12:00/13:00', '16:00']
  }
}
export default class Chart {
  constructor(svg, themeColor) {
    this.svg = d3
      .select(svg)
      .attr('width', '280')
      .attr('height', '200')
    this.svg.html('')
    this.root = this.svg
      .append('g')
      .attr('transform', `translate(${margin.left}, ${margin.top})`)
    this.themeColor = themeColor
  }

  resize(market) {
    this.size = [this.svg.style('width'), this.svg.style('height')].map(
      t => +t.replace('px', '')
    )
    this.width = this.size[0] - margin.left - margin.right
    this.height = this.size[1] - margin.top - margin.bottom
  }

  render(data, market) {
    this.root.html('')
    this.resize(market)

    this.x = d3
      .scaleBand()
      .range([0, this.width])
      .domain(
        data.map(d => {
          return d.time
        })
      )
    this.y = d3
      .scaleLinear()
      .range([this.height, 0])
      .domain(d3.extent(data, d => d.amount))

    this.drawXGrid(data, market)
    this.drawYGrid(data)
    this.drawX(data, market)
    this.drawLine(data, market)
  }

  drawXGrid(data, market) {
    const times = marketTimes.HK.times
    const startTime = this.getTime(data, times[0])
    const centerTime = this.getTime(data, times[1])
    const centerTime2 = this.getTime(data, times[2])
    const endTime = this.getTime(data, times[3])

    this.x1 = d3
      .scaleTime()
      .range([0, marketTimes[market].range[1]])
      .domain([startTime, centerTime])
    this.x2 = d3
      .scaleTime()
      .range([marketTimes[market].range[1], this.width])
      .domain([centerTime2, endTime])
    // add the X gridlines
    this.root
      .append('g')
      .attr('class', 'grid')
      .attr('transform', `translate(0, ${this.height})`)
      .attr('fill', '#DDD')
      .call(
        d3
          .axisBottom(this.x1)
          .ticks(d3.timeMinute.every(60))
          .tickSize(-this.height)
          .tickFormat('')
      )

    this.root
      .append('g')
      .attr('class', 'grid')
      .attr('transform', `translate(0, ${this.height})`)
      .attr('fill', '#DDD')
      .call(
        d3
          .axisBottom(this.x2)
          .ticks(d3.timeMinute.every(60))
          .tickSize(-this.height)
          .tickFormat('')
      )
  }

  drawYGrid(data) {
    // add the Y gridlines
    this.root
      .append('g')
      .attr('class', 'grid')
      .call(
        d3
          .axisLeft(this.y)
          .ticks(5)
          .tickSize(-this.width)
          .tickFormat(d => {
            const num = Math.abs(d)
            if (num >= 1000 && num <= 100000) {
              return round(d / 1000, 2) + 'K'
            } else if (num < 1000) {
              return d
            } else if (num >= 100000 && num <= 1000000000) {
              return round(d / 1000000, 2) + 'M'
            } else if (num > 1000000000) {
              return round(d / 1000000000, 2) + 'B'
            }
            return d
          })
      )
      .append('text')
      .attr('fill', '#DDD')
      .attr('transform', 'rotate(-90)')
  }

  drawX(data, market) {
    // add the x-axis
    this.axis = d3
      .scaleOrdinal()
      .range(marketTimes[market].range)
      .domain(marketTimes[market].ticks)
    this.root
      .append('g')
      .attr('transform', `translate(0, ${this.height})`)
      .attr('class', 'x-axis')
      .call(d3.axisBottom(this.axis))
  }

  drawLine(data, market) {
    // add the line
    const RATE = data.length / marketTimes[market].totalseconds
    const valueLine = d3
      .line()
      .x(d => this.x(d.time) * RATE)
      .y(d => this.y(d.amount))

    this.root
      .append('path')
      .data([data])
      .attr('class', 'line')
      .attr('fill', 'none')
      .attr('stroke', this.themeColor)
      .attr('stroke-linejoin', 'round')
      .attr('stroke-linecap', 'round')
      .attr('stroke-width', 1)
      .attr('d', valueLine)
  }

  getTime(data, time) {
    const date = data[0] ? data[0].time : new Date()
    const newDate = moment(date).format('YYYY-MM-DD') + ' ' + time
    return new Date(newDate).getTime()
  }
}
